import Main from './MainContainer';
import Home from './HomeContainer';
import Dashboard from './DashboardContainer';
import Events from './EventsContainer';
import Plugins from './PluginsContainer';
import Auth from './auth';
import Setup from './setup';
import AWS from './aws';

export default {
  Main,
  Home,
  Dashboard,
  Auth,
  Setup,
  AWS,
  Events,
  Plugins,
};



// WEBPACK FOOTER //
// ./src/containers/index.js